// extracted by mini-css-extract-plugin
export default {"h2":"zTDClu6f","roboto":"k2csCl8K"};